module.exports = __webpack_public_path__ + "media/video1-pc.cb9b9ffa.mp4";